import './new_session_modal_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SurveysNewSessionModalView extends Monitoring.Views.SocialContents.NewSessionModalView
  template: JST['backbone/templates/monitoring/sessions/surveys_new_session_modal']
  className: 'modal start-new-session-modal surveys-new-session-modal'

  initialize: ({
    @mustShowAnalysisButton
    @uuid
    @sortedAvailableChannelsByProvider
    @SurveyTopicsView
  }) ->
    @selectedChannelUids = []

  render: ->
    @$el.html @template()
    @

  activeMode: ->
    'survey'

  _shouldEnableSearchButton: ->
    @SurveyTopicsView?.anySurveySelected()
